export const getNewChipFilterState = ({
  currentState,
  clickedTaxonomy,
  clickedValue
}) => {
  const retVal = {}

  Object.keys(currentState).forEach(key => {
    if (clickedTaxonomy === key) {
      retVal[key] = [clickedValue]
    } else {
      retVal[key] = false
    }
  })

  return retVal
}

export const resetTaxonomyFilters = currentState => {
  const retVal = {}

  Object.keys(currentState).forEach(key => {
    retVal[key] = false
  })

  return retVal
}

export const arrayContainsArray = (superset, subset) => {
  if (0 === subset.length) {
    return false
  }
  return subset.every(function(value) {
    return superset.indexOf(value) >= 0
  })
}
